import { MoreHorizontal } from "lucide-react";
import { MANUAL_STAGES } from "../../lib/pipeline";
import {
  ResponsiveDropdownMenu as DropdownMenu, ResponsiveDropdownMenuContent as DropdownMenuContent,
  ResponsiveDropdownMenuItem as DropdownMenuItem, ResponsiveDropdownMenuSeparator as DropdownMenuSeparator,
  ResponsiveDropdownMenuTrigger as DropdownMenuTrigger,
} from "../ui/responsive-dropdown-menu";

// The « … » menu of a prospect (card and quick panel): everything that is not one of the two visible actions, and the full
// keyboard / touch alternative to dragging ("Déplacer vers…").
export default function ProspectActionsMenu({ prospect: p, actions, can, canAssign, canMove, onOpen, onQuick, onMove, targetClass, align = "end", testPrefix = "kanban" }) {
  const targets = MANUAL_STAGES.filter((s) => s.id !== p.status);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Actions pour ${p.pharmacy_name || "ce prospect"}`}
          data-testid={`${testPrefix}-menu-${p.id}`}
          className={`${targetClass} flex items-center justify-center rounded text-slate-500 hover:bg-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-jamora`}
        >
          <MoreHorizontal size={16} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} title={p.pharmacy_name || "Actions"} className="w-56">
        <DropdownMenuItem onClick={() => onOpen(p)} data-testid={`${testPrefix}-open-${p.id}`}>Ouvrir la fiche</DropdownMenuItem>
        {can.createTask && !actions.some((a) => a.id === "plan") ? (
          <DropdownMenuItem onClick={() => onQuick("plan", p)} data-testid={`${testPrefix}-plan-${p.id}`}>Planifier une action</DropdownMenuItem>
        ) : null}
        {canAssign ? (
          <DropdownMenuItem onClick={() => onQuick("assign", p)} data-testid={`${testPrefix}-assign-${p.id}`}>Changer de responsable</DropdownMenuItem>
        ) : null}
        {canMove ? (
          <>
            <DropdownMenuSeparator />
            <div className="px-2 py-1 text-2xs font-semibold uppercase tracking-wider text-slate-500">Déplacer vers…</div>
            {targets.map((s) => (
              <DropdownMenuItem key={s.id} onClick={() => onMove(p, s.id)} data-testid={`${testPrefix}-move-${p.id}-${s.id}`}>{s.label}</DropdownMenuItem>
            ))}
          </>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
